export default {
  wallet_summary: (state) => state.wallet_summary,
  shipments: (state) => state.shipments,
  shipments_pagination: (state) => state.shipments_pagination,
  shipment_detail: (state) => state.shipment_detail,
  wallet_movements: (state) => state.wallet_movements,
  wallet_movements_pagination: (state) => state.wallet_movements_pagination,
  error_msg: (state) => state.error_msg,
};
